import { render, staticRenderFns } from "./CalendarDateList.vue?vue&type=template&id=97a5770c&"
import script from "./CalendarDateList.vue?vue&type=script&lang=js&"
export * from "./CalendarDateList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports